import React, { useContext, useRef, useEffect } from 'react';
import * as MenuListUI from 'components/MenuList';
import { SelectContext } from './Select';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Option(_ref) {
  var value = _ref.value,
    icon = _ref.icon,
    isDisabled = _ref.isDisabled,
    indentationLevel = _ref.indentationLevel,
    children = _ref.children;
  var itemRef = useRef(null);
  var _useContext = useContext(SelectContext),
    itemList = _useContext.itemList,
    setSelectedItem = _useContext.setSelectedItem;
  var _itemList$useItem = itemList.useItem({
      ref: itemRef,
      value: value !== null && value !== void 0 ? value : children,
      text: children,
      disabled: isDisabled
    }),
    id = _itemList$useItem.id,
    select = _itemList$useItem.select,
    selected = _itemList$useItem.selected,
    highlight = _itemList$useItem.highlight,
    useHighlighted = _itemList$useItem.useHighlighted;
  useEffect(function () {
    if (selected) {
      setSelectedItem({
        ref: itemRef,
        text: children,
        value: value !== null && value !== void 0 ? value : children
      });
    }
  }, [selected, children, value, setSelectedItem]);
  useEffect(function () {
    if (selected) {
      highlight();
    }
  }, [selected]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(MenuListUI.Item, {
    ref: itemRef,
    id: id,
    role: "option",
    "aria-selected": selected,
    "aria-disabled": isDisabled,
    onClick: select,
    onMouseEnter: highlight,
    onMouseLeave: itemList.clearHighlightedItem,
    children: /*#__PURE__*/_jsxs(MenuListUI.Link, {
      forwardedAs: "span",
      isActive: selected,
      isDisabled: isDisabled,
      isHighlighted: useHighlighted(),
      indentationLevel: indentationLevel,
      children: [icon && /*#__PURE__*/_jsx(MenuListUI.ItemIcon, {
        name: icon
      }), children]
    })
  });
}
export default Option;